import { chakra, forwardRef, HTMLChakraProps, Tooltip, TooltipProps } from '@chakra-ui/react';

import { formatTime } from '@/utils/date';

export interface ICueProps extends Omit<HTMLChakraProps<'div'>, 'onClick'> {
  cue: VTTCue;
  isActive?: boolean;
  containerRef?: TooltipProps['portalProps']['containerRef'];
  onClick?: (cue: VTTCue) => void;
}

export const Cue = forwardRef<ICueProps, 'div'>(({ isActive, cue, containerRef, onClick, ...rest }, ref) => {
  const time = formatTime(cue.startTime);

  const handleOnClick = () => onClick?.(cue);

  return (
    <Tooltip label={time} size="sm" placement="top" portalProps={{ containerRef }}>
      <chakra.span
        role="button"
        ref={ref}
        data-active={isActive ? 'true' : undefined}
        _active={{
          bg: 'white',
          color: 'black',
        }}
        _hover={{
          bg: 'violet.500',
          color: 'white',
        }}
        _notFirst={{
          _before: {
            content: '" "',
          },
        }}
        onClick={handleOnClick}
        dangerouslySetInnerHTML={{ __html: cue.text }}
        {...rest}
      />
    </Tooltip>
  );
});

// :not(:first-child)
